export function normalizeLogoUrl(url: string | null | undefined): string {
  if (!url || url.trim() === '') {
    return '/default-logo.png';
  }
  
  // If already a full URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Ensure leading slash
  let normalized = url.startsWith('/') ? url : `/${url}`;
  
  // Add 'company-' prefix if missing for known company logos
  const knownLogos = [
    'etrade-logo.png',
    'wealthfront-logo.png',
    'coinbase-logo.png',
    'schwab-logo.png',
    'robinhood-logo.png',
    'vanguard-logo.png',
    'fidelity-logo.jpg',
    'tdameritrade-logo.png',
    'acorns-logo.png',
    'tiaa-logo.png',
    'sofi-logo.png'
  ];
  
  if (!normalized.startsWith('/company-') && knownLogos.some(logo => normalized.includes(logo))) {
    normalized = `/company-${normalized.substring(1)}`;
  }
  
  return normalized;
}

export function getBrokerageLogoUrl(brokerage: string | null | undefined): string {
  if (!brokerage) {
    return '/default-logo.png';
  }
  
  const lowerBrokerage = brokerage.toLowerCase();
  
  // Map brokerage names to logo filenames
  const logoMap: Record<string, string> = {
    'etrade': '/company-etrade-logo.png',
    'e*trade': '/company-etrade-logo.png',
    'wealthfront': '/company-wealthfront-logo.png',
    'coinbase': '/company-coinbase-logo.png',
    'schwab': '/company-schwab-logo.png',
    'charles schwab': '/company-schwab-logo.png',
    'robinhood': '/company-robinhood-logo.png',
    'vanguard': '/company-vanguard-logo.png',
    'fidelity': '/company-fidelity-logo.jpg',
    'tdameritrade': '/company-tdameritrade-logo.png',
    'acorns': '/company-acorns-logo.png',
    'tiaa': '/company-tiaa-logo.png',
    'sofi': '/company-sofi-logo.png',
  };
  
  return logoMap[lowerBrokerage] || '/default-logo.png';
}

